import { render, staticRenderFns } from "./DeleteGiveawayModal.vue?vue&type=template&id=e8b44e94&scoped=true"
import script from "./DeleteGiveawayModal.vue?vue&type=script&lang=js"
export * from "./DeleteGiveawayModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteGiveawayModal.vue?vue&type=style&index=0&id=e8b44e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b44e94",
  null
  
)

export default component.exports